import { render, staticRenderFns } from "./VerCodeDialog.vue?vue&type=template&id=6451e822&scoped=true"
import script from "./VerCodeDialog.vue?vue&type=script&lang=js"
export * from "./VerCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./VerCodeDialog.vue?vue&type=style&index=0&id=6451e822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6451e822",
  null
  
)

export default component.exports